export class MobileMenu {
    constructor() {
        $('[data-mobile-menu-toggle]').on('click', function () {
                $('[data-mobile-menu]').slideToggle();
            }
        )
        $('[data-dropdown-menu]').on('click',
            function () {
                let targetDropdown = $(this).data('dropdown-menu');
                $(this).toggleClass('c-menu-mobile__link-dropdown--open');
                $(targetDropdown).toggle();
            }
        )
    }
}
